import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { closeModal, getCommunicationSettings } from 'Store/actions';
import Drawer from 'Components/Drawer';
import { withMixpanel } from 'Utils/mixpanel';
import EnvironmentManager from 'Utils/environmentManager';
import { trackEvent } from 'Utils/analytics';
import Icon from 'Components/Icon';
import History from 'Store/history';

function EmailVerification ({ mixpanel }) {
  const history = useHistory();
  const modalData = useSelector(state => state.modalData);
  const auth = useSelector(state => state.auth);
  const dispatch = useDispatch();

  const CMS_BUTTON_CONTACT_PERMISSION = EnvironmentManager.getMessageText({ key: 'button_contact_permission' }) || 'İletişim İzinlerini Düzenle';
  const CMS_DESCRIPTION_EMAIL_ONE_LAST_TRANSACTION_ACTIONSHEET = EnvironmentManager.getMessageText({ key: 'description_email_one_last_transaction_actionsheet' });
  const CMS_TITLE_TRANSACTION_COMPLETE_ACTIONSHEET = EnvironmentManager.getMessageText({ key: 'title_transaction_complete_actionsheet' }) || 'İşlem Tamam';
  const CMS_BUTTON_DONE_ACTIONSHEET = EnvironmentManager.getMessageText({ key: 'button_done_actionsheet' }) || 'Tamam';
  const CMS_DESCRIPTION_TRANSACTION_COMPLETE_ACTIONSHEET = EnvironmentManager.getMessageText({ key: 'description_transaction_complete_actionsheet' });
  const CMS_TITLE_ONE_LAST_TRANSACTION_ACTIONSHEET = EnvironmentManager.getMessageText({ key: 'title_one_last_transaction_actionsheet' }) || 'Son Bir İşlem Kaldı!';
   
  const { data: { campaignEmail, campaignSms, campaignCallCenter }, isFetched: campaignInfoFetched  } = useSelector(state => state.communicationSettings);
  
  const [permissionContent, setPermissionContent] = useState({
    content: '',
    title: '',
    buttonLabel: '',
    onClick: () => {}
  });

  const isModalOpen = modalNameRequest => {
    const { modalNames } = modalData;
    return modalNames.some(modalName => modalName === modalNameRequest);
  };

  useEffect(() => {
    if (auth.isAuthenticated) {
      dispatch(getCommunicationSettings());
    }
  }, [auth.isAuthenticated]);

  useEffect(() => {

    const trackEventData = {
      date: new Date(),
      userId: auth?.data?.userId,
    };

    if (isModalOpen('sendVerificationEmailSuccessModal')) {
      trackEvent('confirm_email', trackEventData);
    }

    if (isModalOpen('verifyEmailSuccessModal')) {
      trackEvent('approved_email', trackEventData);
    }

    if (!campaignInfoFetched)
      return;

    if (!campaignEmail && !campaignSms && !campaignCallCenter) {
      setPermissionContent({
        content: CMS_DESCRIPTION_EMAIL_ONE_LAST_TRANSACTION_ACTIONSHEET,
        title: CMS_TITLE_ONE_LAST_TRANSACTION_ACTIONSHEET,
        buttonLabel: CMS_BUTTON_CONTACT_PERMISSION,
        onClick: () => {
          History.push('/ayarlar/iletisim-izinleri');
          mixpanel.track('Click Edit Contact Permission Button');
          dispatch(closeModal('verifyEmailSuccessModal'));
        }
      });
    } else {
      setPermissionContent({
        content: CMS_DESCRIPTION_TRANSACTION_COMPLETE_ACTIONSHEET,
        title: CMS_TITLE_TRANSACTION_COMPLETE_ACTIONSHEET,
        buttonLabel: CMS_BUTTON_DONE_ACTIONSHEET,
        onClick: () => {
          mixpanel.track('View Completed Sheet');
          dispatch(closeModal('verifyEmailSuccessModal'));
        }
      });
    }
  }, [modalData, campaignInfoFetched, campaignEmail, campaignSms, campaignCallCenter]);

  let modal = {
    title: '',
  };

  let message = {
    props: {
      type: 'none',
    }
  };

  if (isModalOpen('verifyEmailSuccessModal')) {

    modal = {
      ...modal,
      icon: <Icon iconName='svgThumpsUp' />,
      onClose: () => {
        dispatch(closeModal('verifyEmailSuccessModal'));
      },
      title: permissionContent.title !== '' ? permissionContent?.title : EnvironmentManager.getMessageText({ key: 'title_transaction_complete_actionsheet' }),
    };

    message = {
      ...message,
      props: {
        ...message?.props,
        buttonArea: {
          primaryButton: {
            label: permissionContent.buttonLabel !== '' ? permissionContent?.buttonLabel : 'Tamam',
            onClick: () => {
              permissionContent.onClick();
              dispatch(closeModal('verifyEmailSuccessModal'));
            }
          }
        },
      },
      text: permissionContent.content
    };
  }

  if (isModalOpen('verifyEmailErrorModal')) {
    const error = modalData.verifyEmailErrorModal?.error || {};
    const isExpiredToken = error?.code === 4072;

    modal = {
      ...modal,
      icon: isExpiredToken ? <Icon iconName='svgAlert' /> : <Icon iconName='svgWarningYellow' />,
      onClose: () => {
        dispatch(closeModal('verifyEmailErrorModal'));
      },
    };

    const defaultMessage = isExpiredToken ? 'Sayın üyemiz kullanmış olduğunuz link geçerliliğini kaybetmiştir.' : 'Sayın üyemiz bu link daha önce kullanılmıştır.';
    message = {
      ...message,
      props: {
        ...message?.props,
        buttonArea: isExpiredToken ?  {
          primaryButton: {
            label: EnvironmentManager.getMessageText({ key: 'button_expire_confirm_email' }) || 'TEKRAR GÖNDER',
            onClick: () => {
              history.push('/kisisel-bilgilerim/e-posta-adresim');
              dispatch(closeModal('verifyEmailErrorModal'));
            },
          },
        } : {},
      },
      text: EnvironmentManager.getMessageText({
        key: isExpiredToken ? 'text_expire_confim_email' : 'text_used_confirm_email'
      }) || defaultMessage
    };
  }

  if (isModalOpen('sendVerificationEmailSuccessModal')) {
    const email = modalData?.sendVerificationEmailSuccessModal?.email;

    modal = {
      ...modal,
      icon: <Icon iconName={ 'svgLike' } />,
      onClose: () => {
        dispatch(closeModal('sendVerificationEmailSuccessModal'));
        if (history.location.pathname === '/kisisel-bilgilerim/e-posta-adresim') {
          history.goBack();
        } else {
          history.push('/kisisel-bilgilerim');
        }
      },
    };

    const text = EnvironmentManager.getMessageText({ key: 'text_sent_confirm_email ' })
    || 'Tebrikler E-posta doğrulama linkiniz {E_POSTA} adresine gönderilmiştir. Mailinize gelen linke tıklayarak işleminizi tamamlayabilirsiniz.';
    message = {
      ...message,
      text: text.replace('{E_POSTA}', email || auth?.data?.email),
    };
  }

  
  return (
    <Drawer
      { ...modal }
      open={ isModalOpen('verifyEmailErrorModal') ||  isModalOpen('sendVerificationEmailSuccessModal') || isModalOpen('verifyEmailSuccessModal') }
      { ...message?.props }
    >
      <div className='email-verification__title'>
        { message?.text !== '' ? message?.text : EnvironmentManager.getMessageText({ key: 'description_transaction_complete_actionsheet' }) }
      </div>
    </Drawer>
  );
}

EmailVerification.propTypes = {
  history: PropTypes.object,
  auth: PropTypes.object,
  mixpanel: PropTypes.object,
};

export default withMixpanel(EmailVerification);
